import { jsx } from "react/jsx-runtime";
import { FloatingDelayGroup } from "@floating-ui/react";
const hoverDelay = { open: 300, close: 0 };
const TooltipProvider = ({ children }) => /* @__PURE__ */ jsx(FloatingDelayGroup, { delay: hoverDelay, timeoutMs: 300, children });
TooltipProvider.displayName = "TooltipProvider";
export {
  TooltipProvider,
  hoverDelay
};
//# sourceMappingURL=TooltipProvider.js.map
